function Communications () {
    this.createUrl = Communications_createUrl;
}
function Communications_createUrl (serverUrl, handlerAction, commType) {
    var commUrl = new JDURL(serverUrl);
    commUrl.appendParam(PAGEACTIONHF, handlerAction);
    commUrl.appendParam(REQUESTTYPE, commType);
    return commUrl;
}
